module.exports = __webpack_public_path__ + "img/offical1.cb9bf6c8.png";